import _ from "lodash";
import {
	ContractDetailType,
	ContractParty,
} from "../../../requests_cm/gecoContractsService/types";
import { BookType } from "../../../requests_cm/gecoReferentialService/types";

export interface CounterpartyFormik {
	party: ContractParty | undefined;
	mirror_book: BookType | string | undefined;
	trading_book: BookType | string | undefined;
	way: "Buy" | "Sell" | undefined;
	contract_uid: string | undefined;
}

export const counterpartyTabFormikInitialValueMapper = (
	data: ContractDetailType | undefined
): CounterpartyFormik => {
	return {
		party: data?.party,
		mirror_book: data?.mirror_book?.id
			? String(data?.mirror_book?.id)
			: undefined,
		trading_book: data?.trading_book?.id
			? String(data?.trading_book?.id)
			: undefined,
		way: data?.way,
		contract_uid: data?.contract_uid,
	};
};

export const counterpartyFormikToContractDetailMapper = (
	formikData: CounterpartyFormik,
	initialContract: ContractDetailType
): ContractDetailType => {
	const updatedContract = _.cloneDeep(initialContract) as ContractDetailType;
	updatedContract.party = formikData.party as ContractParty;
	updatedContract.way = formikData.way;
	if (formikData.contract_uid) {
		updatedContract.contract_uid = formikData.contract_uid;
	}
	if (formikData?.mirror_book) {
		updatedContract.mirror_book = formikData.mirror_book as BookType;
		updatedContract.mirror_book_owner = formikData.party
			?.mnemonic as string;
	}
	if (formikData?.trading_book) {
		updatedContract.trading_book = formikData.trading_book as BookType;
	}

	return updatedContract;
};
